import { render, staticRenderFns } from "./EmployeeExtraInformation.vue?vue&type=template&id=f0103924&lang=pug&"
import script from "./EmployeeExtraInformation.vue?vue&type=script&lang=js&"
export * from "./EmployeeExtraInformation.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeExtraInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmployeeExtraInformation.vue"
export default component.exports